import { QFilter } from '@/types';
import callBackendApi from './call';

export const getQuickFilterListPreview = async (
  token: string,
  qFilter: QFilter,
  domainCode: string,
  abortSignal?: AbortSignal
) => {
  const qFilterJson = JSON.stringify(qFilter);
  let data;

  const urlForEncoding = `/filters/preview?qFilter=${encodeURIComponent(
    qFilterJson
  )}&domainCode=${domainCode}`;

  if (abortSignal) {
    data = await callBackendApi({
      token,
      method: 'get',
      endpoint: urlForEncoding,
      abortSignal,
    });
  } else {
    data = await callBackendApi({
      token,
      method: 'get',
      endpoint: urlForEncoding,
    });
  }
  return data;
};
